<template lang="pug">
v-card.d-flex.ai-center.jc-center(height='calc(100vh - 112px)' color="background" :class="{'fd-column' : isMovil}")
  v-card.pa-2.ma-4(
    :name="index" :id="items.length - 1"
    :color="r.id === indexItems ? 'primary white--text' : ''"
    :to="r.path"
    height="100"
    width="300"
    hover,
    v-for="(r, index) in items"
    :key="index"
  )
    .d-flex.ai-center
      v-icon(left='' size="57" color="primary")
        | {{r.icon}}
      .flex-1.d-flex.fd-column
        span.font-weight-700.font-size-20(:class="{'font-size-17' : isMovil}") {{r.title}}
        small.font-size-12(:class="{'white--text' : r.id === indexItems}") {{r.descripcion}}
</template>
<script>
export default {
  data () {
    return {
      items: [
        {
          title: 'Parametros',
          icon: 'room_preferences',
          descripcion : 'Administrador de parametros de la aplicacion',
          path : '/manager/parametros'
        },
        {
          title: 'Estados',
          icon: 'linear_scale',
          descripcion : 'Administrador de estados de tipos de ticket',
          path : '/manager/estados'
        },
        {
          title: 'Usuarios',
          icon: 'supervised_user_circle',
          descripcion : 'Administrador usuarios de la aplicacion',
          path : '/manager/usuarios'
        }
        // {
        //   title: 'Roles (permisos)',
        //   icon: 'admin_panel_settings',
        //   descripcion : 'Administrador de roles y permisos',
        //   path : '/manager/roles'
        // }
      ],
      drawer: null,
      indexItems : ''
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>



// WEBPACK FOOTER //
// View_manager.vue?19209a2d